import React, { useState, useEffect } from "react";
import Button from "../../components/ui/Button";
import EditText from "../../components/ui/EditText";

import emailjs from "@emailjs/browser";

const ContactFormSection = ({ formData, handleInputChange, onSuccess }) => {
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  // Captcha State
  const [captchaAnswer, setCaptchaAnswer] = useState("");
  const [captchaQuestion, setCaptchaQuestion] = useState({ q: "", a: 0 });

  useEffect(() => {
    generateCaptcha();
  }, []);

  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    setCaptchaQuestion({ q: `${num1} + ${num2}`, a: num1 + num2 });
  };

  const validate = () => {
    let tempErrors = {};

    // Helper: Checks for empty, leading space, or script tags
    const isInvalid = (val) => {
      if (!val || val.toString().trim() === "") return true;
      if (val.startsWith(" ")) return true; // Block leading spaces
      if (/<|>/g.test(val)) return true; // Block potential script tags
      return false;
    };

    // 1. Name Validation
    if (isInvalid(formData.firstName))
      tempErrors.firstName = "First Name is required (No leading spaces)";
    if (isInvalid(formData.lastName))
      tempErrors.lastName = "Last Name is required";

    // 2. Email Validation
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (isInvalid(formData.emailId)) {
      tempErrors.emailId = "Email Id is required";
    } else if (!emailRegex.test(formData.emailId)) {
      tempErrors.emailId = "Enter a valid email (e.g. info@utpann.in)";
    }

    // 3. Phone Validation
    const phoneRegex = /^[0-9]{10}$/;
    if (isInvalid(formData.contactNo)) {
      tempErrors.contactNo = "Contact No. is required";
    } else if (!phoneRegex.test(formData.contactNo)) {
      tempErrors.contactNo = "Enter a valid 10-digit number";
    }

    // 4. Enquiry & Country
    if (!formData.enquiryType)
      tempErrors.enquiryType = "Please select an enquiry type";
    if (isInvalid(formData.country)) tempErrors.country = "Country is required";

    // --- NEW: State & City Validation ---
    if (isInvalid(formData.state)) {
      tempErrors.state = "State is required (No leading spaces)";
    }
    if (isInvalid(formData.city)) {
      tempErrors.city = "City is required (No leading spaces)";
    }

    // 5. Captcha
    if (parseInt(captchaAnswer) !== captchaQuestion.a) {
      tempErrors.captcha = "Incorrect captcha answer";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };
  const onFormSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    try {
      const payload = {
        first_name: formData.firstName,
        last_name: formData.lastName,
        email: formData.emailId,
        contact_no: formData.contactNo,
        enquiry_type: formData.enquiryType,
        country: formData.country,
        state: formData.state,
        city: formData.city,
        message: formData.message,
        captcha_question: `${captchaQuestion.q} = ?`,
        captcha_answer: captchaAnswer,
      };

      const response = await fetch(
        "https://www.govardhannathjienergies.com/api/utpann-submit-inquiry.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      console.log("API Response:", data);

      if (!response.ok || data.status === false) {
        throw new Error(data.message || "Failed to submit enquiry");
      }

      // Success
      setIsSubmitted(true);
      setCaptchaAnswer("");
      generateCaptcha();

      if (onSuccess) onSuccess();

      setTimeout(() => {
        setIsSubmitted(false);
      }, 5000);
    } catch (error) {
      console.error("Submission error:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <section className="relative w-full py-0 sm:py-8 md:py-12">
      <div className="w-full max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 flex flex-col lg:flex-row gap-10 lg:gap-[100px] md:mt-[100px] justify-center items-center">
        {/* Contact Information (Same as original) */}
        <div className="flex flex-col gap-6 md:gap-[30px] flex-shrink-0">
          <ContactInfoItem
            icon="/assets/icon/callIcon.png"
            text="+91 86458 88881"
            link="tel:+91864588881"
          />
          <ContactInfoItem
            icon="/assets/icon/mailIcon1.png"
            text="info@utpann.in"
            link="mailto:info@utpann.in"
          />
          <ContactInfoItem
            icon="/assets/icon/locationIcon1.png"
            text=" Sr. No. 2373, Sim Vistar, At&Po-Pij, Ta-Vaso, Dist-Kheda, Gujarat INDIA 387230"
            link="https://maps.google.com"
          />
        </div>

        {/* Contact Form Updated with new fields */}

        {/* Form - Added noValidate here to stop browser popup */}
        <div className="md:flex-1 w-full sm:flex justify-center">
          <form
            onSubmit={onFormSubmit}
            noValidate
            className="w-full md:max-w-[900px]"
          >
            <div className="bg-black/20 backdrop-blur-md border border-white rounded-md md:rounded-[30px] p-4 md:p-8 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-x-[40px] md:gap-y-6">
              <FormInput
                label="First Name*"
                name="firstName"
                value={formData.firstName}
                onChange={handleInputChange}
                error={errors.firstName}
              />
              <FormInput
                label="Last Name*"
                name="lastName"
                value={formData.lastName}
                onChange={handleInputChange}
                error={errors.lastName}
              />

              <FormInput
                label="Email Id*"
                name="emailId"
                type="email"
                value={formData.emailId}
                onChange={handleInputChange}
                error={errors.emailId}
              />
              <FormInput
                label="Contact No.*"
                name="contactNo"
                type="tel"
                value={formData.contactNo}
                onChange={handleInputChange}
                error={errors.contactNo}
              />

              {/* Enquiry Select */}
              <div className="flex flex-col gap-2">
                <label className="text-[18px] md:text-[24px] font-medium text-white">
                  Select Enquiry Type*
                </label>
                <select
                  name="enquiryType"
                  value={formData.enquiryType}
                  onChange={handleInputChange}
                  className={`bg-transparent text-white border border-white rounded-[14px] p-3 outline-none ${errors.enquiryType ? "border-red-500" : ""}`}
                >
                  <option value="" className="text-black">
                    Select Enquiry Type
                  </option>

                  <option value="General" className="text-black">
                    General Inquiry
                  </option>

                  <option value="Product" className="text-black">
                    Product Information
                  </option>

                  <option value="Sales" className="text-black">
                    Sales & Partnership
                  </option>

                  <option value="Support" className="text-black">
                    Technical Support
                  </option>
                </select>
                {errors.enquiryType && (
                  <span className="text-red-500 text-[14px] font-bold bg-white/10 px-2 rounded-md w-fit">
                    {errors.enquiryType}
                  </span>
                )}
              </div>

              <FormInput
                label="Country*"
                name="country"
                value={formData.country}
                onChange={handleInputChange}
                error={errors.country}
              />
              <FormInput
                label="State"
                name="state"
                value={formData.state}
                onChange={handleInputChange}
                error={errors.state}
              />
              <FormInput
                label="City*"
                name="city"
                value={formData.city}
                onChange={handleInputChange}
                error={errors.city}
              />

              <div className="flex flex-col gap-2 md:col-span-2">
                <label className="text-[18px] md:text-[24px] font-medium text-white">
                  Message*
                </label>

                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  placeholder="Write your message"
                  rows="4"
                  className="bg-transparent text-white border border-white rounded-[14px] p-3 outline-none"
                ></textarea>
              </div>
              {/* Captcha */}

              <div className="flex gap-4">
                <div className="bg-white rounded-lg p-4 flex items-center justify-between shadow-sm border border-gray-200 min-h-[60px] w-full max-w-[280px]">
                  <span className="text-[#1a202c] text-[24px] font-bold tracking-widest font-mono">
                    {captchaQuestion.q} = ?
                  </span>

                  <button
                    type="button"
                    onClick={generateCaptcha}
                    className="text-gray-500 hover:text-black transition-colors"
                  >
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              <div>
                <EditText
                  placeholder="Enter Captcha Result*"
                  value={captchaAnswer}
                  onChange={(e) => setCaptchaAnswer(e.target.value)}
                  error={errors.captcha}
                  className={`bg-transparent text-white border border-white rounded-[14px] p-3 ${errors.captcha ? "border-red-500" : ""}`}
                />
                {errors.captcha && (
                  <span className="text-red-500 text-[14px] font-bold bg-white/10 px-2 rounded-md w-fit mt-2">
                    {errors.captcha}
                  </span>
                )}
              </div>

              {/* Submit */}
              <div className="flex flex-col justify-end">
                <Button
                  type="submit"
                  text={loading ? "Submitting..." : "Submit"}
                  disabled={loading}
                  className="hover:bg-white hover:text-black transition-all text-white px-6 py-3 border border-white rounded-[30px]"
                />

                {isSubmitted && <SuccessDisplay />}
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

// --- FormInput Component with Red Error Fix ---
const FormInput = ({ label, error, ...props }) => (
  <div className="flex flex-col gap-2">
    <label className="text-[18px] md:text-[24px] font-medium text-white">
      {label}
    </label>
    <EditText
      {...props}
      className={`bg-transparent text-white border rounded-[14px] p-3 outline-none ${error ? "border-red-500" : "border-white"}`}
    />
    {error && (
      <span className="text-red-500 text-[14px] font-bold bg-white/10 px-2 rounded-md w-fit">
        {error}
      </span>
    )}
  </div>
);

// (Baki sub-components jaise SuccessDisplay, ContactInfoItem same rahenge...)
const SuccessDisplay = () => (
  <div className="flex items-center gap-2 mt-4 animate-in fade-in slide-in-from-top-1 duration-300">
    <div className="bg-[#10b981] flex items-center justify-center rounded-full w-6 h-6">
      <svg
        className="w-4 h-4 text-white"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>

    <span className="text-[#10b981] font-['Parkinsans'] font-medium text-[18px]">
      Successfully saved!
    </span>
  </div>
);
const ContactInfoItem = ({ icon, text, link }) => (
  <a
    href={link}
    target={link.startsWith("http") ? "_blank" : "_self"}
    rel="noreferrer"
    className="flex items-start gap-3 md:gap-[10px] group cursor-pointer"
  >
    <div className="w-[40px] h-[40px] md:w-[50px] md:h-[50px] flex-shrink-0 flex justify-center items-center bg-[#000] border border-white rounded-full group-hover:bg-white/20 transition-all">
      <img src={icon} alt="icon" />
    </div>

    <span className="text-[20px] md:text-[28px] font-medium text-black lg:text-white font-['Parkinsans'] flex-1 max-w-[400px] group-hover:underline underline-offset-4">
      {text}
    </span>
  </a>
);

export default ContactFormSection;
